export default "__VITE_ASSET__HHqA6CT$__"